import type { ReactNode } from "react"
import type { LinkComponent } from "@/components/new/LoggedInUser"

type NavItem = { href: string; label: ReactNode }

// Required, not defaulted — a default value here would still need a
// static import of some concrete link component at module scope, which
// would poison any bundle importing this file even when the prop is
// never used. Same DI shape LoggedInUser.tsx already established; every
// real caller (AppShell's/AdminShell's AppLink, App.tsx's PublicLink)
// passes its own plain-anchor implementation explicitly.
export function TopNav({
  brand,
  backHref,
  items,
  rightItems,
  loggedInUser,
  linkComponent: Link,
}: {
  brand?: ReactNode
  backHref?: string
  items: NavItem[]
  rightItems?: NavItem[]
  loggedInUser?: ReactNode
  linkComponent: LinkComponent
}) {
  return (
    <header className="bg-nav border-b border-white/10 print:hidden">
      <nav className="mx-auto flex h-12 max-w-5xl items-center gap-6 px-4 text-sm">
        {brand}
        {backHref ? (
          <Link href={backHref} aria-label="Back" className="text-zinc-100 hover:text-white">
            &lt;
          </Link>
        ) : null}
        {items.map((item) => (
          <Link key={item.href} href={item.href} className="text-zinc-100 hover:text-white">
            {item.label}
          </Link>
        ))}
        <div className="ml-auto flex items-center gap-6">
          {rightItems?.map((item) => (
            <Link key={item.href} href={item.href} className="text-zinc-100 hover:text-white">
              {item.label}
            </Link>
          ))}
          {loggedInUser}
        </div>
      </nav>
    </header>
  )
}
